import { render, staticRenderFns } from "./AccountsReceivableHistoryDialog.vue?vue&type=template&id=47c68ef4"
import script from "./AccountsReceivableHistoryDialog.vue?vue&type=script&lang=ts"
export * from "./AccountsReceivableHistoryDialog.vue?vue&type=script&lang=ts"
import style0 from "./AccountsReceivableHistoryDialog.vue?vue&type=style&index=0&id=47c68ef4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports